import { z } from "zod";
import type { CategoryPlugin } from "../plugin";

const schema = z.object({});

export const plugin: CategoryPlugin<z.infer<typeof schema>> = {
  metadata: {
    id: "future-collections", slug: "future-collections", name: "Future Collections",
    tagline: "Coming soon", status: "coming-soon",
  },
  attributeSchema: schema,
  search: { columns: ["name"], attributes: [] },
  facets: [],
  pdpPanels: [],
  seo: {
    titleTemplate: "{name} · CB16 Coming Soon",
    descriptionTemplate: "{name} — a future CB16 collection.",
    routePrefix: "future-collections",
  },
  adminForm: [],
};
